/* global WebFont */

import WebFont from 'webfontloader';

WebFont.load({
  google: {
    families: ['Open Sans:400:latin-ext'],
  },
});
